import LUploadImg from './src/main'

/* istanbul ignore next */
LUploadImg.install = function(Vue) {
  Vue.component(LUploadImg.name, LUploadImg)
}

export default LUploadImg
